import profileApi from './../../api/auth';
import { setToken, getToken, clearToken } from '../../utils/tokenStorage'
import * as actionTypes from './actionTypes'

const profileRequest = () => ({
  type: actionTypes.PROFILE_REQUEST
});

const profileReceive = data => ({
  type: actionTypes.PROFILE_RECEIVE,
  data,
});

const profileError = error => ({
  type: actionTypes.PROFILE_ERROR,
  error,
});

export const profileInvalidate = () => ({
  type: actionTypes.PROFILE_INVALIDATE,
});

export const profileFetch = () => dispatch => {
  dispatch(profileRequest());
	return profileApi.user().then(data => dispatch(profileReceive(data))).catch(error => console.log(error));
};

export const profileLogin = (data) => dispatch => {
  dispatch(profileRequest());
  return profileApi.login(data).then(data => {
    if (data && data.token) {
      setToken(data.token)
    }

    const storageToken = getToken()

    if (storageToken) {
      return dispatch(profileFetch())
    }
  }).catch(error => dispatch(profileError(error)));
};

export const profileLogout = () => dispatch => {
  clearToken();
  window.location.reload();
};

export const profileUpdateStages = (data) => (dispatch, getState) => {
  dispatch({ type: actionTypes.PROFILE_UPDATE_STAGES_REQUEST })

  const profileState = JSON.parse(JSON.stringify(getState().profile))
  const profileData = profileState.data
  const stage = profileData ? profileData.user.stage : null
  const stagesData = {
    stage: {
      name: stage,
      payload: data || {}
    }
  }

  return profileApi.updateStages(stagesData).then(data => {
    profileData.user.stage = data.next_stage_name

    return dispatch({
      type: actionTypes.PROFILE_UPDATE_STAGES_RECEIVE,
      data: profileData,
      result: data.result
    })
  }).then(() => dispatch(profileFetch())).catch((error) => {
    dispatch({
      type: actionTypes.PROFILE_UPDATE_STAGES_ERROR,
      error,
    });
    throw error;
  });
}

const profileShouldFetch = state => {
  const profileState = state;
  if (profileState.isFetching) {
    return true;
  }
  if (!profileState.data) {
    return false;
  }
  return profileState.didInvalidate;
};

export const profileFetchIfNeeded = () => (dispatch, getState) => {
  if (!profileShouldFetch(getState().profile)) {
    return Promise.resolve();
  }
  return dispatch(profileFetch());
};

export const profileClearStagesResult = () => (dispatch, getState) => {
  dispatch({
    type: actionTypes.PROFILE_CLEAR_STAGES_RESULT,
  })
}





// WEBPACK FOOTER //
// ./src/store/profile/actions.js